const DEFAULT_DEV_API_BASE_URL = 'http://localhost:8081'
const LEGACY_PRODUCTION_GATEWAY_HOST = 'gw.api-luck66.com'

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

const isLocalDevelopmentHost = (hostname: string): boolean => (
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.startsWith('127.0.0.') ||
  hostname.includes('localhost')
)

const shouldUseSameOriginForConfiguredBase = (configuredBaseUrl: string): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const hostname = window.location.hostname
  if (isLocalDevelopmentHost(hostname)) {
    return false
  }

  try {
    const parsedUrl = new URL(configuredBaseUrl)
    return parsedUrl.hostname === LEGACY_PRODUCTION_GATEWAY_HOST && parsedUrl.hostname !== hostname
  } catch {
    return false
  }
}

export const resolveConfiguredBaseUrl = (configuredBaseUrl: unknown): string | null => {
  if (configuredBaseUrl === undefined || configuredBaseUrl === null) {
    return null
  }

  const normalizedConfiguredBaseUrl = trimTrailingSlash(String(configuredBaseUrl))
  if (normalizedConfiguredBaseUrl === '') {
    return ''
  }

  if (shouldUseSameOriginForConfiguredBase(normalizedConfiguredBaseUrl)) {
    return ''
  }

  return normalizedConfiguredBaseUrl
}

export const getApiBaseUrl = (): string => {
  const resolvedConfiguredBaseUrl = resolveConfiguredBaseUrl((import.meta.env as any).VITE_API_BASE_URL)
  if (resolvedConfiguredBaseUrl !== null) {
    return resolvedConfiguredBaseUrl
  }

  if (import.meta.env.DEV) {
    return DEFAULT_DEV_API_BASE_URL
  }

  return ''
}

export const withApiBaseUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const baseUrl = getApiBaseUrl()
  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath
}
